import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCaptcha = ({
  onVerify,
}: {
  onVerify: (token: string | null) => void;
}) => {
  const [verified, setVerified] = useState(false);

  const handleVerify = (token: string | null) => {
    if (token) {
      setVerified(true);
      onVerify(token);
    }
  };

  return (
    <div className="my-4">
      <ReCAPTCHA
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
        onChange={handleVerify}
      />
    </div>
  );
};

export default ReCaptcha;
